export const MAX_DURATION = 299;
export const MIN_DURATION = 31;
export const DURATION_INFINITY_HIGH = 300;
export const DURATION_INFINITY_LOW = 30;
